// ═══════════════════════════════════════════════════════════════════════════════
// Public membership pricing table (marketing site + Admin catalog)
// ═══════════════════════════════════════════════════════════════════════════════
export const MEMBERSHIP_PRICING_LOCALES = ['en', 'zh-Hant', 'zh-Hans'];
/** Catalog item keys. `accounts` and `pricing` are locked (always on, pinned first). */
export const MEMBERSHIP_PRICING_ITEM_KEYS = [
    'accounts',
    'pricing',
    'task_kinds',
    'max_total_tasks',
    'max_daily_task_submits',
    'max_daily_task_reviews',
    'max_daily_receipts',
    'max_daily_ai_analyze',
    'max_comments_per_target',
    'max_comment_length',
    'pin_max_items',
    'pin_title_max_length',
    'pin_content_max_length',
    'max_inventory_locations',
    'max_inventory_categories',
    'auto_translation',
    'storage_retention',
    'receipt_budget',
];
export const MEMBERSHIP_PRICING_LOCKED_KEYS = ['accounts', 'pricing'];
//# sourceMappingURL=membershipPricing.js.map